import {useEffect} from 'react';
import {useRouter} from 'next/router';
import Script from 'next/script';

import {GoogleTagManagerProps, WindowWithDataLayer} from './GoogleTagManager.types';

const onViewPage = (url: string) => {
  const _window = window as unknown as WindowWithDataLayer;

  if (typeof _window?.dataLayer !== 'undefined') {
    _window.dataLayer.push({event: 'pageview', page: url});
  } else {
    console.log({event: 'pageview', page: url});
  }
};

/**
 * This component mounts the Google Tag Manager provided script tag & iframe
 * fallback.
 *
 * Usage of NextJS's `Script` component, alongside the `afterInteractive`
 * strategy prop value ensures that the script tag will be placed in the
 * appropriate location in the document's `<head>` regardless of where this
 * component is mounted.
 *
 * For more information, see:
 * - https://nextjs.org/docs/app/api-reference/components/script#afterinteractive
 */
export const GoogleTagManager = ({containerId}: GoogleTagManagerProps) => {
  const {pathname, query} = useRouter();

  useEffect(() => {
    if (!!containerId && !!pathname) {
      onViewPage(pathname);
    }
  }, [containerId, pathname, query]);

  return !!containerId ? (
    <>
      <noscript>
        <iframe
          height="0"
          src={`https://www.googletagmanager.com/ns.html?id=${containerId}`}
          style={{display: 'none', visibility: 'hidden'}}
          width="0"
        />
      </noscript>

      <Script
        dangerouslySetInnerHTML={{
          __html: `
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer', '${containerId}');
          `,
        }}
        id="gtm-script"
        strategy="afterInteractive"
      />
    </>
  ) : null;
};
